// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2Dw01","content":"GlobalSearch_content__3hPAr"};